import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { ArrowUpRight, Megaphone } from 'lucide-react';

export const AnnouncementTicker = ({ announcements }) => {
  const [index, setIndex] = useState(0);
  const [paused, setPaused] = useState(false);
  useEffect(() => {
    if (paused || announcements.length < 2 || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    const interval = setInterval(() => setIndex(value => (value + 1) % announcements.length), 12000);
    return () => clearInterval(interval);
  }, [announcements.length, paused]);
  const announcement = announcements[index % announcements.length];
  return <Link to="/announcements" className="hidden md:flex flex-1 min-w-0 items-center mx-4 h-9 bg-red-50 rounded-md border border-red-100 text-xs overflow-hidden"
    onMouseEnter={() => setPaused(true)} onMouseLeave={() => setPaused(false)} onFocus={() => setPaused(true)} onBlur={() => setPaused(false)}
    aria-label={announcement ? `Read announcement: ${announcement.title}` : 'Announcements'} data-testid="announcement-ticker">
    <span className="self-stretch flex shrink-0 items-center gap-1.5 bg-red-600 text-white px-3 font-semibold">
      <Megaphone className="h-3.5 w-3.5" /><span className="hidden lg:inline">Announcements</span>
    </span>
    <span className="flex-1 min-w-0 truncate px-3" data-testid="announcement-ticker-message">
      {announcement ? `${announcement.title} · ${announcement.content}` : 'No announcements at the moment.'}
    </span>
    <ArrowUpRight className="h-4 w-4 mr-3 shrink-0 text-red-700" />
  </Link>;
};